<template>
    <b-modal
        id="ModalUpdateDataselection"
        size="xl"
        title="Modifier une sélection de données"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormDataselection
            v-bind:projectId="projectId"
            v-bind:datasource="datasource"
            v-bind:dataselection="dataselection"
            @saved="onSaved"
            class="mb-4"
        />
    </b-modal>
</template>
<script>
import FormDataselection from "@/components/model/dataselection/FormDataselection";
export default {
    components: {
        FormDataselection,
    },
    props: {
        projectId: {
            required: true,
            type: [String, Number],
        },
        datasource: {
            required: true,
            type: Object,
        },
        dataselection: {
            required: false,
            type: Object,
        },
    },
    methods: {
        onSaved() {
            this.$bvModal.hide("ModalUpdateDataselection");
            this.$emit("saved");
        },
    },
};
</script>
